let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cHkhr")).then(() => parcelRequire('7W04t'));